import CryptoJS from "crypto-js";
import { urlApi } from "../../constant";

const getBrandToken = (): string => {
    return CryptoJS.AES.encrypt(
      process.env.REACT_APP_DEV_api_app_id,
      process.env.REACT_APP_DEV_api_app_secret
    ).toString();
  },
  authorizationData: string = JSON.stringify({
    brand: process.env.REACT_APP_DEV_api_app_brandKey,
    brandToken: getBrandToken(),
    user: { role: "guest" },
  }),
  headerOptions = {
    // 'Content-Type': 'multipart/form-data',
    Accept: "*",
    "Access-Control-Allow-Credentials": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Origin": "*",
    "Upgrade-Insecure-Requests": "1",
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
    Authorization: "Bearer " + authorizationData,
    // 'Content-Type': 'application/json'
    // 'Content-Type': 'application/x-www-form-urlencoded',
  };
export const postToUrl = (url: string, data: any) => {
  fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "omit", // include, *same-origin, omit
    headers: headerOptions,
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: data, // body data type must match "Content-Type" header
  });
};
export const postData = async (url = "", data: any) => {
  try {
    return await fetch(urlApi + url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "omit", // include, *same-origin, omit
      headers: headerOptions,
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: data, // body data type must match "Content-Type" header
    }).then((response) => response.json());
  } catch (error) {
    return error;
  }
};
export const getFromUrl = async (url: string) => {
  try {
    return await fetch(url, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "omit", // include, *same-origin, omit
      headers: headerOptions,
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    }).then((response) => response.json());
  } catch (error) {
    return error;
  }
};
export const getData = async (url: string) => {
  try {
    return await fetch(urlApi + url, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "omit", // include, *same-origin, omit
      headers: headerOptions,
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    }).then((response) => response.json());
  } catch (error) {
    return error;
  }
};
